<template>
  <div>
    <Head title="Rinisja e dërgesës"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/dergesat">Dërgesat</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      <Link class="text-indigo-400 font-medium" :href="`/admin/dergesat/${order.id}`">{{ order.id }}</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      Rinis

    </h1>

    <div class=" bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input  v-model="form.business_id" :error="form.errors.business_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Biznesi shitës">
            <option v-for="business in businesses" :key="business.id" :value="business.id" >{{ business.name }}</option>
          </select-input>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Pika marrëse:</label>
            <select v-model="form.location_id" :error="form.errors.location_id" class="form-select focus:ring-0 hover:border-indigo-500" >
              <option v-for="location in selectedLocations" :key="location.id" :value="location.id">{{ location.name }}</option>
            </select>
          </div>

          <text-input v-model="form.custom_id" :error="form.errors.custom_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID e sistemit tuaj" />



        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e dërgesës</h3>
          <select-input v-model="form.package_size_id" :error="form.errors.package_size_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Madhësia e pakos">
            <option v-for="packageSize in packageSizes"  :key="packageSize.id" :value="packageSize.id">{{ packageSize.name }}  {{ packageSize.description }}</option>
          </select-input>

          <select-input v-model="form.fragile" :error="form.errors.fragile" class="pb-8 pr-6 w-full lg:w-1/4" label="A është pako fragjile(e dëmtueshme)">
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.openable" :error="form.errors.openable" class="pb-8 pr-6 w-full lg:w-1/4" label="A mund të hapet pako">
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <text-input v-model="form.quantity" :error="form.errors.quantity" class="pb-8 pr-6 w-full lg:w-1/4" label="Sasia e produktit" />

          <text-input v-model="form.product_name" :error="form.errors.product_name" class="pb-8 pr-6 w-full lg:w-1/4" label="Emri i produktit" />
          <text-input v-model="form.product_description" :error="form.errors.product_description" class="pb-8 pr-6 w-full lg:w-1/4" label="Përshkrimi i produktit(opsionale)" />
          <text-input v-model="form.product_price" :error="form.errors.product_price" class="pb-8 pr-6 w-full lg:w-1/4" label="Çmimi i produktit" />
          <text-input v-model="form.shipping_price" :error="form.errors.shipping_price" class="pb-8 pr-6 w-full lg:w-1/4" label="Çmimi i postës" disabled />

        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e klientit</h3>
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/4" label="Emri & Mbiemri" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4" label="Telefoni" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/4" label="Telefoni (sekondar)" />

          <select-input  v-model="form.country_id" :error="form.errors.country_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Shteti">
            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }} </option>
          </select-input>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Qyteti:</label>
            <select v-model="form.city_id" :error="form.errors.city_id" class="form-select focus:ring-0 hover:border-indigo-500" >
              <option v-for="city in selectedCities" :key="city.id" :value="city.id">{{ city.name }}</option>
            </select>
          </div>

          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/4" label="Adresa" />

          <select-input v-model="form.area_type" :error="form.errors.area_type" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="Qytet/Fshat"
          >
            <option :value="null" selected>Zgjedh</option>
            <option value="qytet">Qytet</option>
            <option value="fshat">Fshat</option>
          </select-input>

          <textarea-input v-model="form.additional_info" :error="form.errors.additional_info" class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë" />


        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Regjistro</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import axios from 'axios'
import {computed} from 'vue'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Modal,
    FileInput
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    packageSizes: Array,
    locations: Array,
    businesses: Array,
    order: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        custom_id: this.order.custom_id,
        business_id: this.order.business_id,
        location_id: this.order.location_id,
        package_size_id: this.order.package_size_id,
        fragile: this.order.fragile,
        openable: this.order.openable,
        quantity: this.order.quantity.toString(),
        product_name: this.order.product_name,
        product_description: this.order.product_description,
        product_price: this.order.product_price,
        name:this.order.name,
        phone: this.order.phone,
        second_phone: this.order.second_phone,
        country_id: this.order.country_id,
        city_id: this.order.city_id,
        address: this.order.address,
        area_type: this.order.area_type,
        additional_info: this.order.additional_info,
        shipping_price: this.order.shipping_price,
        is_recreated: true,
        old_order_id: this.order.id
      }),
      selectedLocations: this.locations,
      selectedCities: this.cities,
    }
  },
  mounted() {
    this.getShippingPrice()
  },
  methods: {
    store() {
      this.form.post(route('admin.orders.store.recreate'))
    },
    getShippingPrice(){
      let self = this
      axios.get('/ajax/shipping-pricing',{
        params: {
          business_id: this.form.business_id,
          country_id: this.form.country_id,
          package_size_id: this.form.package_size_id,
        }
      }).then(function (result){
        self.form.shipping_price = result.data.pricing.shipping_price;
      });

    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations',{
        params: {
          business_id: this.form.business_id,
        }
      }).then(function (result){
        self.selectedLocations = result.data.locations;
        self.form.location_id = result.data.locations[0].id
      });
    },
    getCities(){
      let self = this
      self.form.selectedCities = []
      axios.get('/ajax/list/cities',{
        params: {
          country_id: this.form.country_id,
        }
      }).then(function (result){
        self.selectedCities = result.data.cities;
        self.form.city_id = result.data.cities[0].id
      });
    },
  },
  watch: {
    'form.business_id'(businessId) {
      this.getLocations()
      this.getShippingPrice()
    },
    'form.country_id'(countryId){
      this.getShippingPrice()
      this.getCities()
    },
    'form.package_size_id'(packageSizeId){
      this.getShippingPrice()
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
